import { Move } from "@/types";
import { humanize } from "@/lib/utils";
import { formatDistanceToNow, format } from "date-fns";
import { Activity } from "@/types";
import { ACTIVITY_ACTION_TYPES } from "@/constants";

const Timeline = ({ move }: { move: Move }) => {
  return (
    <>
      <ul className="space-y-3">
        {move.activities.map((activity: Activity, index: number) => (
          <li key={index}>
            <div className="flex flex-col-reverse lg:flex-row lg:grid lg:grid-cols-12 gap-0.5 lg:gap-4 border-b border-gray-300 pb-2 border-dashed">
              <div className="col-span-3">
                <div className="flex flex-row lg:flex-col items-baseline lg:items-start gap-1 text-sm text-gray-700">
                  <div className="text-xs font-normal text-black">
                    {formatDistanceToNow(activity.created_at)} ago
                  </div>
                  <div className="text-xs text-gray-700">
                    {format(activity.created_at, "MM/dd/yyyy")}{" "}
                    {format(activity.created_at, "h:mm a")}
                  </div>
                </div>
              </div>
              <div className="col-span-9">
                <p className="text-sm font-semibold mb-1">
                  {ACTIVITY_ACTION_TYPES[
                    activity.action as keyof typeof ACTIVITY_ACTION_TYPES
                  ] || humanize(activity.action)}
                  {activity.type === "sales" &&
                    activity.sales_properties.outcome && (
                      <span className="text-sm font-semibold">
                        {" "}
                        -{" "}
                        {humanize(
                          activity.sales_properties.outcome
                        ).toLowerCase()}
                      </span>
                    )}
                </p>
                {activity.metadata && (
                  <p className="text-sm text-gray-700">
                    {activity.metadata.description && (
                      <div
                        className="text-sm prose max-w-none max-h-[200px] overflow-y-auto"
                        dangerouslySetInnerHTML={{
                          __html: activity.metadata.description,
                        }}
                      />
                    )}
                  </p>
                )}
                {activity.metadata && (
                  <p className="text-sm text-gray-700">
                    {activity.metadata.notes && (
                      <p className="text-sm">{activity.metadata.notes}</p>
                    )}
                  </p>
                )}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </>
  );
};

export default Timeline;
